export function OverrideConsole() {
    // @ts-expect-error yup
    if (window._____consoleOverriden) return;
    Object.defineProperty(window, '_____consoleOverriden', {configurable: true, enumerable: true, writable: true, value: true});

    const ogLog   = console.log;
    const ogWarn  = console.warn;
    // const ogError = console.error;
    const ogDebug = console.debug;

    console.info   = (...params: unknown[]) => ogLog(`%c[${new Date().toLocaleString()}]`  , 'border-radius: 1px; color:black; background-color: rgb(190, 190, 190)', ...params);
    console.warn  = (...params: unknown[]) => ogWarn(`%c[${new Date().toLocaleString()}]` , 'border-radius: 1px; color:black; background-color: rgb(255, 205, 88)', ...params);
    // console.error = (...params: unknown[]) => ogError(`%c[${new Date().toLocaleString()}]`, 'border-radius: 1px; color:black; background-color: #ff6d6d', ...params, new Error().stack);
    console.debug = (...params: unknown[]) => ogDebug(`%c[${new Date().toLocaleString()}]`, 'border-radius: 1px; color:white; background-color: rgb(255, 0, 183)', ...params);
}